const obj = {
    formlist: [
        {
            showField: "销售单号",
            defaultValue: "",
            entityField: "woamId",
            extractId: 557468838825984,
            fieldType: "search",
            setField: "woamId",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 1, isUpdate: 0
        },
        {
            showField: "类型",
            defaultValue: "",
            entityField: "rmType",
            extractId: null,
            fieldType: "radio",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "销售日期",
            defaultValue: "",
            entityField: "woamSaledate",
            extractId: null,
            fieldType: "date",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "销售单位",
            defaultValue: "",
            entityField: "cmName",
            extractId: null,
            fieldType: "search",
            setField: "cmName,cmId",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "业务员",
            defaultValue: "",
            entityField: "opmName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            setField: "opmName,opmId",
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "业务部门",
            defaultValue: "",
            entityField: "depName",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "对方业务员",
            defaultValue: "",
            entityField: "salesName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            setField: "salesName,salesId",
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "地址",
            defaultValue: "",
            entityField: "caiAddress",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "收货员",
            defaultValue: "",
            entityField: "recName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            setField: "recName,recId",
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "货主名称",
            defaultValue: "",
            entityField: "coName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            setField: "coName,coId",
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "手术时间",
            defaultValue: "",
            entityField: "operationTime",
            extractId: null,
            fieldType: "date",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "科室",
            defaultValue: "",
            entityField: "roomName",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "病人姓名",
            defaultValue: "",
            entityField: "patientName",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "住院号",
            defaultValue: "",
            entityField: "courtNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "病人电话",
            defaultValue: "",
            entityField: "patientPhone",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "身份证号",
            defaultValue: "",
            entityField: "idcardNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "备注",
            defaultValue: "",
            entityField: "wsRemark",
            extractId: null,
            fieldType: "string",
            fieldWeight: 180,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
    ],
    details: [
        {
            showField: "商品编号",
            defaultValue: "",
            entityField: "bgmCode",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "商品名称",
            defaultValue: "",
            entityField: "bgmName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            focusField: "",
            nosetField: "woadPnumber,psprice,psmoney,price,money,woadRemark",
            riftField: "bgmId",
            searchId: 919354910904320,
            setField: "bgmName,bgmId",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "规格",
            defaultValue: "",
            entityField: "spec",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "生产厂商",
            defaultValue: "",
            entityField: "manufacturer",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "产地",
            defaultValue: "",
            entityField: "placeorigin",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "包装单位",
            defaultValue: "",
            entityField: "bgpUnitmeasurement",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "装箱规格",
            defaultValue: "",
            entityField: "packingSpec",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "批号",
            defaultValue: "",
            entityField: "batchno",
            extractId: null,
            fieldType: "string",
            fieldWeight: 120,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "生产日期",
            defaultValue: "",
            entityField: "prodate",
            extractId: null,
            fieldType: "date",
            fieldWeight: 110,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "失效日期",
            defaultValue: "",
            entityField: "expidate",
            extractId: null,
            fieldType: "date",
            fieldWeight: 110,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "灭菌批号",
            defaultValue: "",
            entityField: "sterBatchno",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "销售数量",
            defaultValue: "",
            entityField: "woadPnumber",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "keydown",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "使用数量",
            defaultValue: "",
            entityField: "useNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "keydown",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "已回库数量",
            defaultValue: "",
            entityField: "recycleNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "keydown",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
        {
            showField: "本次回库数量",
            defaultValue: "",
            entityField: "returningNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "keydown",
            isShow: 1,
            isChange: 0, isUpdate: 0
        },
    ],
    detailslist:[
        {
            showField: "商品编号",
            defaultValue: "",
            entityField: "bgmCode",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "商品名称",
            defaultValue: "",
            entityField: "bgmName",
            extractId: null,
            fieldType: "search",
            fieldWeight: 180,
            focusField: "",
            nosetField:"woadPnumber,psprice,psmoney,price,money,woadRemark",
            riftField:"bgmId",
            searchId: 919354910904320,
            setField:"bgmName,bgmId",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "规格",
            defaultValue: "",
            entityField: "spec",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "生产厂商",
            defaultValue: "",
            entityField: "manufacturer",
            extractId: null,
            fieldType: "string",
            fieldWeight: 150,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "产地",
            defaultValue: "",
            entityField: "placeorigin",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "包装单位",
            defaultValue: "",
            entityField: "bgpUnitmeasurement",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "装箱规格",
            defaultValue: "",
            entityField: "packingSpec",
            extractId: null,
            fieldType: "string",
            fieldWeight: 100,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "批号",
            defaultValue: "",
            entityField: "batchno",
            extractId: null,
            fieldType: "string",
            fieldWeight: 120,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "生产日期",
            defaultValue: "",
            entityField: "prodate",
            extractId: null,
            fieldType: "date",
            fieldWeight: 110,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "失效日期",
            defaultValue: "",
            entityField: "expidate",
            extractId: null,
            fieldType: "date",
            fieldWeight: 110,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "灭菌批号",
            defaultValue: "",
            entityField: "sterBatchno",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "",
            isChange: 0, isUpdate: 0
        },
        {
            showField: "回库数量",
            defaultValue: "",
            entityField: "recycleNum",
            extractId: null,
            fieldType: "string",
            fieldWeight: 110,
            focusField: "keydown",
            isChange: 0, isUpdate: 0
        },
    ]
}
export default obj
